<template>
  <CDialog
    :visible.sync="visible"
    :title="$t('Edit account info')"
    submittable
    :submit-label="$t('Save Changes')"
    :submit-loading="loading"
    @submit="save"
    @open="resetData"
  >
    <form>
      <fieldset class="form-group">
        <label>{{ $t('Account name') }}</label>
        <input type="text" class="form-control" v-model="name" />
      </fieldset>
    </form>
  </CDialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { CalcDialogSize } from '@/lib/tools';

import CDialog from '@/components/uikit/CDialog';

const messages = {
  en: {
    'Account info': 'Account Info',
    'Save Changes': 'Save',
    'Edit account info': 'Edit Account Info',
    'Account name': 'Name',
  },
  ja: {
    'Account info': 'アカウント情報',
    'Save Changes': '設定を保存',
    'Edit account info': 'アカウント情報の変更',
    'Account name': 'アカウント名',
  },
};

export default {
  name: 'DialogEditAccount',
  i18n: { messages },
  components: {
    CDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dialogWidth: null,
      name: '',
    };
  },
  created() {
    this.dialogWidth = CalcDialogSize();
  },
  computed: {
    ...mapState('accounts', {
      selectedId: state => state.selectedId,
      details: state => state.details,
    }),

    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions('accounts', ['fetchAccounts', 'fetchDetail', 'putAccountName']),
    save() {
      this.loading = true;

      this.putAccountName(this.name)
        .then(() => {
          this.fetchAccounts({ force: true });
          this.fetchDetail({ force: true });

          this.$alpha.notify.success('update', this.$t('Account info'));

          this.visible = false;
        })
        .catch(() => {
          this.$alpha.notify.error('update', this.$t('Account info'));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetData() {
      this.name = this.details[this.selectedId]['account_name'];
    },
  },
};
</script>
